function taxonomize(mapping: Record<string, string>, key: string, defaultValue: string) {
  return mapping?.[key] || defaultValue;
}

export default taxonomize;
